export const BRAND_CONFIG = Object.freeze({
  paysafecard: {
    name: 'Paysafecard',
    hasCertifiedBadge: true,
    hasTermsAndConditions: true,
    hasExtraPaymentInformation: true,
  },
})
